import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./Layout.css";
import Main from "./Main";

const Layout = ({ children }) => {
  const [labels, setLabels] = useState([]);
  const role = localStorage.getItem("userRole");

  const [selectedSection, setSelectedSection] = useState(
    role === "Admin" ? "Configuration" : "View Broadcast"
  );

  useEffect(() => {
    const adminLabels = [
      "Configuration",
      "View Configuration",
      "User And Email Broadcast Management",
      "Manual Rate Broadcast",
      "View Broadcast",
    ];

    const userLabels = ["View Broadcast", "View Configuration"];
    setLabels(role === "Admin" ? adminLabels : userLabels);
  }, [role]);

  return (
    <main>
      <div className="flex h-screen">
        <div className="flex-1 flex flex-col overflow-hidden">
          <header className="flex justify-between items-center">
            <Header />
          </header>
          <div className="flex h-full">
            <Sidebar labels={labels} onSelectSection={setSelectedSection} />
            <main className="flex flex-col w-full overflow-x-hidden overflow-y-auto mb-14">
              <Main screen={selectedSection} />
              {children}
            </main>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Layout;
